module.exports = __webpack_public_path__ + "static/img/1028_big.55394ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1028_big.png
// module id = Nviw
// module chunks = 1